import uuidv4 from 'uuid/v4';

class WebGLElement {
  constructor(component, element) {
    this.component = component;
    this.id = uuidv4();
    element.dataset.webglId = this.id;
    this.component.$el.dataset.webglId = this.id;

    window.addEventListener('webgl-initial', (event) => {
      if (event.detail.id === this.id) this.initial();
    });
    window.addEventListener('webgl-in', (event) => {
      if (event.detail.id === this.id) this.in();
    });
  }

  init() {}

  render() {}

  resize() {}
}

export default WebGLElement;
